// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import {
  put,
  call,
  select,
  takeEvery
} from 'redux-saga/effects';

import {
  getBookshopTotalService,
  getRecentVouchersService,
  searchVouchersService,
} from './service';
import * as vouchersActions from './actions';
import * as types from './actionTypes';
import {
  getText
} from './selectors';
import history from '../../../../../../../services/history';

const VOUCHER_CODE_PATTERN = /^SIB\d{6}$/i;

function* getBookshopTotalSaga() {

  const CustomerId = localStorage.getItem('loggedID');
  const Token = localStorage.getItem('token');

  const data = {
    CustomerId,
    Token,
  };

  const response = yield call(getBookshopTotalService, data);
  if (response.ok) {
    yield put(vouchersActions.getBookshopTotalSuccess(response.body));
  }
}

function* getRecentVouchersSaga() {

  const CustomerId = localStorage.getItem('loggedID');
  const Token = localStorage.getItem('token');

  const data = {
    CustomerId,
    Token,
  };

  yield put(vouchersActions.startRecentLoader());

  const response = yield call(getRecentVouchersService, data);
  if (response.ok) {
    yield put(vouchersActions.getRecentVouchersSuccess(response.body));
  }

  yield put(vouchersActions.stopRecentLoader());
}

function* searchVouchersSaga() {

  const CustomerId = localStorage.getItem('loggedID');
  const Token = localStorage.getItem('token');

  // Trimmed on the way out, not as the operator types: stripping spaces on
  // every keystroke would stop them typing "John Smith" at all. A handheld
  // scanner tends to send a trailing newline or space with the code, and a
  // pasted voucher id often carries one too - neither should reach the search.
  const Text = String((yield select(getText)) || '').trim();

  if (Text !== '') {

    const data = {
      CustomerId,
      Token,
      Text,
    };

    yield put(vouchersActions.startSearchLoader());

    const response = yield call(searchVouchersService, data);
    if (response.ok) {
      yield put(vouchersActions.searchVouchersSuccess(response.body));

      const results = Array.isArray(response.body) ? response.body : [];

      if (VOUCHER_CODE_PATTERN.test(Text) && results.length === 1) {
        yield put(vouchersActions.stopSearchLoader());
        history.push('/account/vouchers/redeem', {
          code: results[0].Code,
          bookshopCustomerId: results[0].BookshopCustomerId,
        });
        return;
      }
    }

    yield put(vouchersActions.stopSearchLoader());
  }
}


const vouchersSagas = [
  takeEvery(types.GET_BOOKSHOP_TOTAL, getBookshopTotalSaga),
  takeEvery(types.GET_RECENT_VOUCHERS, getRecentVouchersSaga),
  takeEvery(types.SEARCH_VOUCHERS, searchVouchersSaga),
];

export default vouchersSagas;
